module.exports = __webpack_public_path__ + "static/img/icon1.deaa06a6.png";